<template>
  <v-dialog v-model="uploadDialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        v-on="on"
        v-bind="attrs"
        color="primary"
        class="text-none"
        :class="className"
        :disabled="!cellName"
      >
        <v-icon small left>
          $upload
        </v-icon>
        Upload
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <form ref="fileform">
          <div  class="text-center">
            <v-icon class="icon-class">mdi-upload</v-icon>
          </div>
          <div  class="text-center">
            <span class="title">
              Upload Quality Document
            </span>
            <br>
            <span class="subtitle-1">
              Select a .png, or .jpg to upload.
            </span>
          </div>
          <div  class="text-center" >
            <label class="custom-file-upload primary" >
              SELECT FILE
              <input
                multiple
                id="files"
                ref="files"
                type="file"
                accept=".jpg, .png"
                @change="handleFilesUpload()"
              />
            </label>
          </div>
          <div v-for="(file, key) in files" class="file-listing" :key="key">
              <!-- <v-flex>
                <img class="preview" v-bind:ref="'preview'+parseInt( key )"/>
              </v-flex> -->
            <v-row>
              <v-col cols="9">
                <span  class="text-name" v-text="file.name"></span>
              </v-col>
              <v-col style="text-align: right;">
                <v-btn
                  text
                  icon
                  small
                  color="red"
                  title="remove"
                  @click="removeFile(key)"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </div>
            <!-- <progress max="100" :value.prop="uploadPercentage"></progress> -->
        </form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="uploadDialog=false"
          text
          color="red"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="submitFiles()"
          :disabled="!files.length"
          class="success"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'FileUplode',
  props: {
    // submachine: {
    //   type: String,
    //   default: undefined,
    // },
    part: {
      type: String,
      default: undefined,
    },
    cellName: {
      type: String,
      default: undefined,
    },
    className: {
      type: String,
    },
  },
  computed: {
    ...mapState('cellwiseQualityDashboard', ['machines']),

    currentAssetId() {
      if (!this.machines || this.machines.length === 0) return 0;

      if (this.cellName) {
        const cellMachine = this.machines.find((m) => {
          const dbCellName = m.machinecell || m.cell || m.cellname;
          return dbCellName === this.cellName;
        });

        if (cellMachine && (cellMachine.assetId || cellMachine.assetid)) {
          return cellMachine.assetId || cellMachine.assetid;
        }
      }

      return this.machines[0].assetId || this.machines[0].assetid || 0;
    },
  },
  data() {
    return {
      files: [],
      uploadPercentage: 0,
      dragAndDropCapable: false,
      uploadDialog: false,
    };
  },

  methods: {
    determineDragAndDropCapable() {
      const div = document.createElement('div');

      return (('draggable' in div)
                || ('ondragstart' in div && 'ondrop' in div))
                && 'FormData' in window
                && 'FileReader' in window;
    },
    getImagePreviews() {
      /*
          Iterate over all of the files and generate an image preview for each one.
        */
      for (let i = 0; i < this.files.length; i += 1) {
        /*
            Ensure the file is an image file
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          /*
              Create a new FileReader object
            */
          const reader = new FileReader();

          /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
          reader.addEventListener('load', () => {
            this.$refs[`preview${parseInt(i, 10)}`][0].src = reader.result;
          }, false);

          reader.readAsDataURL(this.files[i]);
        }
      }
    },

    ...mapActions('cellwiseQualityDashboard', ['postFileData', 'postElementData']),
    ...mapMutations('helper', ['setAlert']),
    addFiles() {
      this.$refs.files.click();
    },
    async submitFiles() {
      const elementData = {
        // submachine: this.submachine,
        partname: this.part,
        cellName: this.cellName,
        Widget: 'Quality Feedback',

      };

      delete elementData.id;
      delete elementData.questions;

      this.files.map(async (file) => {
        const param = file.name.split('.');
        const formData = new FormData();

        formData.append(`files_${param}`, file);

        console.log('[Upload Debug] File type:', file.type);

        const filePayload = {
          formData,
          filename: param[0],
          fileextension: param[param.length - 1].toLowerCase(),
          filetype: 'image',
          filecontent: 'image',
          assetid: this.currentAssetId !== null ? this.currentAssetId : 0,
        };

        if (this.currentAssetId) {
          filePayload.assetid = this.currentAssetId;
        }
        console.log('[Upload Debug] Sending file payload:', filePayload);

        await this.postFileData({ filePayload, elementData });
      });

      this.files = [];
      this.uploadDialog = false;
      this.$refs.files.value = '';
    },
    handleFilesUpload() {
      let validFilename = null;
      const uploadedFiles = this.$refs.files.files;
      for (let i = 0; i < uploadedFiles.length; i += 1) {
        validFilename = /[a-z0-9]/i.test(uploadedFiles[i].name);
        if (validFilename) {
          if (uploadedFiles[i].size < 7340032) {
            this.files.push(uploadedFiles[i]);
          } else {
            this.setAlert({
              show: true,
              type: 'error',
              message: 'INVALID_SIZE',
            });
          }
        } else {
          this.setAlert({
            show: true,
            type: 'error',
            message: 'INVALID_TEXT',
          });
        }
      }
    },
    removeFile(key) {
      this.files.splice(key, 1);
    },
  },
};

</script>

<style>
 form{
    display: block;
    width: 100%;
    overflow: hidden;
  }

  progress{
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .responsive-img {
    height: calc(100vh - 300px);
  }
 .header{
    /* color: black; */
    font-size: 24px;
    padding-left:5px;
    text-align: center;
 }
 .mdi-upload:before{
   font-size: 74px;
    /* color: black; */
 }
 input[type="file"] {
    display: none;
}
.custom-file-upload {
    /* background:white; */
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    color: white;
    margin-left: 5px;
    margin-bottom: 5%;
    border-radius: 4px;
}
.text-name{
    font-size: 14px;
    padding-left: 10px;
}
.submit-btn{
    float: right;
}
</style>
